import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'EXPORT_PROJECT',
    icon: 'menu-export-project',
    label: '出口项目',
    path: '/export-project',
  },
] satisfies Menu[];
